import React from 'react';
import clazz from 'classnames';
import styles from './index.module.less';
export default function Footer(props) {
    const { text, className, style = {} } = props;
    return (<footer style={style} className={clazz(styles.footer, className)}>
      {text}
    </footer>);
}
